import React from 'react';

import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';

const ServerErrorPopup = (props) => {
    const getText = (text) => {
        return <p dangerouslySetInnerHTML={{ __html: text }} />;
    };

    return (
        <SimplePopup popupRef={props.popupRef} text={getText(props.errorText)}>
            <PopupButton
                iconName="check"
                text={props.buttonClose}
                onClick={() => {
                    props.popupRef.current?.close();
                }}
            />
        </SimplePopup>
    );
};

export default ServerErrorPopup;
